<template>
  <footer>
    <div class="footer__wrapper">
      <div class="footer__area">
        <div class="copyright">&copy; Copyright MRT Inc. All Rights Reserved.</div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {}
</script>

<style>
.footer__wrapper {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100px;
  background-color: #0095D9;
}
.copyright{
  color: #ffffff;
  font-size: 1.25rem;
}
@media screen and (max-width: 959px) {
  .copyright{
    color: #ffffff;
    font-size: 1rem;
  }
}
</style>
